import React from 'react';
import Hexagon from '../common/Hexagon';

/**
 * Los cuatro KPIs de la pantalla de alertas.
 *
 * "Situación General" salió del diseño nuevo y en su lugar va "Resueltas este
 * mes": es una cifra, se compara con la de la semana pasada y cabe en la misma
 * fila; "Estable / Atención" era una relectura del conteo de críticas que ya
 * está en la tarjeta de al lado.
 */
const AlertSummaryCards = ({ summary }) => {
  const cards = [
    {
      key: 'activas',
      title: 'Activas',
      value: summary?.requieren_atencion ?? 0,
      icon: 'ri-alarm-warning-line',
      color: '#DC2626',
    },
    {
      key: 'criticas',
      title: 'Críticas',
      value: summary?.criticas ?? 0,
      icon: 'ri-error-warning-line',
      color: '#DC2626',
    },
    {
      key: 'advertencia',
      title: 'Altas',
      value: summary?.advertencia ?? 0,
      icon: 'ri-arrow-up-circle-line',
      color: '#C2740A',
    },
    {
      key: 'resueltas',
      title: 'Resueltas este mes',
      // El resumen no siempre trae el conteo de resueltas; sin dato se muestra
      // una raya, no un cero, que diría "no se resolvió ninguna".
      value: summary?.resueltas ?? summary?.resueltas_mes ?? '—',
      icon: 'ri-checkbox-circle-line',
      color: '#0F9A5A',
    },
  ];

  return (
    <div className="ui-grid-kpis mb-4">
      {cards.map((card) => (
        <div key={card.key} className="ui-card ui-kpi ui-kpi--inline">
          <Hexagon size={46} color={card.color} icon={card.icon} />
          <div>
            <div className="ui-kpi__title">{card.title}</div>
            <div className="ui-kpi__value" style={{ color: card.color }}>
              {typeof card.value === 'number'
                ? card.value.toLocaleString('es-CO')
                : card.value}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertSummaryCards;
